const closeDesktop = document.querySelector('.Header-addedBanner a');
const closeMobile = document.querySelector('.HeaderMobile-addedBanner a');
export const init = async function() {
    if (closeDesktop) {
        closeDesktop.addEventListener('click', ()=>{
            const item = document.querySelector('.Header-addedBanner');
            if (item === null) {
                return;
            }
            if (item instanceof HTMLElement) {
                item.style.transform = 'translateX(-100%)';
            }
        });
    }
    if (closeMobile) {
        closeMobile.addEventListener('click', ()=>{
            const item = document.querySelector('.HeaderMobile-addedBanner');
            if (item === null) {
                return;
            }
            if (item instanceof HTMLElement) {
                item.style.transform = 'translateX(-100%)';
            }
        });
    }
};
